import { createInjectionKey } from '../../_utils';
export const configProviderInjectionKey = createInjectionKey('n-config-provider');
